<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h3>Kelola Pengajuan Izin / Cuti</h3>
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button
                                label="New"
                                icon="pi pi-plus"
                                class="p-button-success mr-2"
                                @click="openNew"
                            />
                            <Button
                                label="Delete"
                                icon="pi pi-trash"
                                class="p-button-danger"
                                @click="confirmDeleteSelected"
                                :disabled="
                                    !selectedModels || !selectedModels.length
                                "
                            />
                        </div>
                    </template>
                </Toolbar>

                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Kelola Pengajuan Izin / Cuti</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                        headerStyle="width: 3rem"
                    ></Column>
                    <Column
                        field="code"
                        header="No"
                        :sortable="true"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column
                        field="master_cuti"
                        header="Kriteria"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Kriteria</span>
                            {{ slotProps.data.master_cuti.name }}
                        </template>
                    </Column>
                    <Column
                        field="name"
                        header="Tanggal"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">tanggal</span>
                            {{ slotProps.data.tanggal.value }}
                        </template>
                    </Column>
                    <Column
                        field="status"
                        header="Status"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">status</span>
                            <Badge :value="slotProps.data.status" class="text-white" :severity="badgeColor[slotProps.data.status]"></Badge>
                        </template>
                    </Column>
                    <Column headerStyle="width:15%;min-width:10rem;">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.status === 'waiting'">
                                <Button
                                    icon="pi pi-pencil"
                                    class="p-button-rounded p-button-success mr-2"
                                    @click="editModel(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-trash"
                                    class="p-button-rounded p-button-warning mt-2"
                                    @click="confirmDeleteModel(slotProps.data)"
                                />
                            </div>
                            <div v-else>
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-rounded p-button-primary mr-2"
                                    @click="detailModel(slotProps.data)"
                                />
                            </div>
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="modelDialog"
                    :style="{ width: '450px' }"
                    header="Ajukan Pengajuan Cuti"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Pilih Cuti</label>
                        <Dropdown v-model="model.mst_cuti_ids" :options="masterVacations" optionLabel="name" placeholder="Pilih Cuti" />
                        <small class="p-invalid" v-if="submitted && !model.mst_cuti_ids"
                            >Master Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal_mulai">Tanggal Mulai</label>
                        <Calendar id="tanggal_mulai" v-model="model.tanggal_mulai" dateFormat="dd-mm-yy" :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal_mulai"
                            >Tanggal Mulai is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal_akhir">Tanggal Akhir</label>
                        <Calendar
                            id="tanggal_akhir"
                            v-model="model.tanggal_akhir"
                            dateFormat="dd-mm-yy"
                            :inline="true"
                        />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal_mulai"
                            >Tanggal Mulai is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Alasan Cuti</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.alasan_cuti"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.alasan_cuti }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.alasan_cuti"
                            >Alasan Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="">Lampiran File</label>
                        <FileUpload mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @select="onUpload($event)" />
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="editModelDialog"
                    :style="{ width: '450px' }"
                    header="Edit Ajukan Pengajuan Cuti"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Pilih Cuti</label>
                        <Dropdown v-model="model.mst_cuti_ids" :options="masterVacations" optionLabel="name" placeholder="Pilih Cuti" />
                        <small class="p-invalid" v-if="submitted && !model.mst_cuti_ids"
                            >Master Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal">Tanggal</label>
                        <Calendar id="tanggal" v-model="model.tanggal" dateFormat="dd-mm-yy" :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal"
                            >Tanggal is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Alasan Cuti</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.alasan_cuti"
                            required="true"
                            autofocus
                            :class="{ 'p-invalid': submitted && !model.alasan_cuti }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.alasan_cuti"
                            >Alasan Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="">Lampiran File</label>
                        <FileUpload mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @select="onUpload($event)" />
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="detailModelDialog"
                    :style="{ width: '450px' }"
                    header="detail Ajukan Pengajuan Cuti"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="name">Pilih Cuti</label>
                        <Dropdown v-model="model.mst_cuti_ids" disabled :options="masterVacations" optionLabel="name" placeholder="Pilih Cuti" />
                        <small class="p-invalid" v-if="submitted && !model.mst_cuti_ids"
                            >Master Cuti is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="tanggal">Tanggal</label>
                        <Calendar id="tanggal" v-model="model.tanggal" dateFormat="dd-mm-yy" disabled :inline="true" />
                        <small
                            class="p-invalid"
                            v-if="submitted && !model.tanggal"
                            >Tanggal is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="name">Alasan Cuti</label>
                        <Textarea
                            id="name"
                            v-model.trim="model.alasan_cuti"
                            required="true"
                            autofocus
                            disabled
                            :class="{ 'p-invalid': submitted && !model.alasan_cuti }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.alasan_cuti"
                            >Alasan Cuti is required.</small
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelsDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete the selected
                            models?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelsDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteSelectedModels"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Checkbox from "primevue/checkbox";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Message from "primevue/message";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import FileUpload from "primevue/fileupload";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
import Textarea from 'primevue/textarea';
import Calendar from 'primevue/calendar';
import Badge from 'primevue/badge';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Checkbox,
        Button,
        InputText,
        Password,
        Message,
        Toolbar,
        Toast,
        FileUpload,
        DataTable,
        Column,
        InputNumber,
        Dropdown,
        RadioButton,
        Dialog,
        Textarea,
        Calendar,
        Badge
    },
    data() {
        return {
            searchFilter: "",
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            badgeColor: {
                'waiting': 'warning',
                'success': 'success',
                'failed': 'danger'
            },
            lazyParams: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            modelDialog: false,
            models: null,
            detailModelDialog: false,
            editModelDialog: false,
            deleteModelDialog: false,
            deleteModelsDialog: false,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            masterVacations: [],
            user: JSON.parse(sessionStorage.getItem('auth:me')),
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
        this.loadMasterVacation();
    },
    methods: {
        loadLazyData() {
            this.lazyParams = {
                ... this.lazyParams,
                where: {
                    user_id: this.user.id
                }
            };
            this.loading = true;
            this.datatableService
                .getData(this.route("api.vacations.index"), this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        loadMasterVacation() {
            axios.get(this.route('api.master-vacations.data'))
            .then((data) => {
                this.masterVacations = data.data.data.data
            })
            .catch(err => {
                console.log(err)
            })
        },
        onSelectAllChange(event) {
            const selectAll = event.checked;
            if (selectAll) {
                this.datatableService.getData(this.route("banks.index"),this.lazyParams).then((data) => {
                    this.selectAll = true;
                    this.selectedModels = data.data;
                });
            } else {
                this.selectAll = false;
                this.selectedModels = [];
            }
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.loadLazyData();
        },
        onUpload(event) {
            this.model.foto_cuti = event.files[0];
        },
        openNew() {
            this.model = {};
            this.submitted = false;
            this.modelDialog = true;
        },
        hideDialog() {
            this.modelDialog = false;
            this.editModelDialog = false;
            this.detailModelDialog = false;
            this.submitted = false;
        },
        saveModel() {
            this.submitted = true;
            if (this.model) {
                if (this.model.id) {
                    let tanggal = new Date(this.model.tanggal)

                    let formData = new FormData()
                    formData.append('alasan_cuti', this.model.alasan_cuti)
                    formData.append('tanggal', `${tanggal.getFullYear()}-${tanggal.getMonth() + 1}-${tanggal.getDate()}`)
                    formData.append('mst_cuti_ids', this.model.mst_cuti_ids.id)
                    formData.append('foto_cuti', this.model.foto_cuti)

                    axios
                        .post(this.route('api.vacations.updates', this.model.id), formData)
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Successful",
                                detail: "Vacation user Updated",
                                life: 3000,
                            });
                            this.loadLazyData();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: "Vacation user not updated",
                                life: 3000,
                            });
                        });
                    this.loadLazyData()
                    this.editModelDialog = false;
                }
                // If empty then add new record
                else {
                    let tanggal_mulai = new Date(this.model.tanggal_mulai)
                    let tanggal_akhir = new Date(this.model.tanggal_akhir)

                    let formData = new FormData()
                    formData.append('alasan_cuti', this.model.alasan_cuti)
                    formData.append('tanggal_mulai', `${tanggal_mulai.getFullYear()}-${tanggal_mulai.getMonth() + 1}-${tanggal_mulai.getDate()}`)
                    formData.append('tanggal_akhir', `${tanggal_akhir.getFullYear()}-${tanggal_akhir.getMonth() + 1}-${tanggal_akhir.getDate()}`)
                    formData.append('mst_cuti_ids', this.model.mst_cuti_ids.id)
                    formData.append('foto_cuti', this.model.foto_cuti)

                    axios
                        .post(this.route('api.vacations.store'), formData)
                        .then((response) => {
                            this.model = response.data.data;
                            this.models.unshift(this.model);
                            this.$toast.add({
                                severity: "success",
                                summary: "Successful",
                                detail: "vacation user Created",
                                life: 3000,
                            });
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: "vacation user not created",
                                life: 3000,
                            });
                        });
                    this.loadLazyData()
                    this.modelDialog = false;
                }
                this.model = {};
            }
        },
        editModel(model) {
            this.model = { ...model, tanggal: new Date(model.tanggal.as), mst_cuti_ids: model.master_cuti };
            this.editModelDialog = true;
        },
        detailModel(model) {
            this.model = { ...model, tanggal: new Date(model.tanggal.as), mst_cuti_ids: model.master_cuti };
            this.detailModelDialog = true;
        },
        confirmDeleteModel(model) {
            this.model = model;
            this.deleteModelDialog = true;
        },
        deleteModel() {
            axios
                .delete(this.route('api.vacations.destroy', this.model.id))
                .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Cuti Deleted",
                        life: 3000,
                    });
                    this.deleteModelDialog = false;
                    this.model = {};
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Bank not deleted",
                        life: 3000,
                    });
                });
        },
        confirmDeleteSelected() {
            this.deleteModelsDialog = true;
        },
        deleteSelectedModels() {
            this.models = this.models.filter(
                (val) => !this.selectedModels.includes(val)
            );
            this.deleteModelsDialog = false;
            this.selectedModels = null;
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Models Deleted",
                life: 3000,
            });
        },
        initFilters() {
            this.filters = {
                global: { field: 'user.name', value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
